import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { GLOBAL_CONTEXT } from '@adornis/users/db/a-roles.js';
import { checkPermissionMiddleware } from '../../permissions/middlewares/checkPermissionMiddleware.js';
import { Permission } from '../../permissions/roles.js';
import { enqueueAccountingMatching } from '../server/accountingMatchingQueue.js';
import { accountingMatching } from '../server/initalizeAccountingMatching.js';
import { openItems } from '../../accounting/server/initalizeOpenItems.js';

const regroupAccountingEntries = registerMutation({
  operationName: 'regroupAccountingEntries',
  type: () => Int,
  params: [],
  // the permission of the admin dashboard, which also guards the import
  middlewares: [checkPermissionMiddleware(Permission.READ_PLATFORM_USAGE, GLOBAL_CONTEXT)],
  resolve: () => async () => {
    // the items read which Lastschrift runs the bank has not credited yet — refresh that before they are rewritten
    await openItems().server!.writeTransitLedgers();
    const accounts = await accountingMatching().server!.listAccounts();
    await enqueueAccountingMatching(accounts, 'manual');
    return accounts.length;
  },
});

export const AccountingMatchingAPI = {
  /** Groups every personal account again, in the background. Returns how many accounts were queued. */
  regroupAll: regroupAccountingEntries,
};
